// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"bede8e26","35":"9edb1351","37":"264bc133","194":"2eb1801d","472":"93e30150","482":"a4905532","533":"1544c133","561":"a0602ef6","787":"0fd34c9b","851":"e72c4d80"}[chunkId] + ".chunk.js";
};